import { render, staticRenderFns } from "./ContentBlockResource.vue?vue&type=template&id=23b1fdb7&"
import script from "./ContentBlockResource.vue?vue&type=script&lang=js&"
export * from "./ContentBlockResource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports